import { UseMutationResult, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { ImpersonationBroker, asApiError } from '../../../extViewmodels';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { KEYWORD_PINS_TYPE, type KeywordPinView } from '../pins/serverTypes';
import { queryKeys } from './queryKeys';

export type UpdateKeywordPinVariables = {
	id: string;
	row: KeywordPinView;
};

export function useUpdateKeywordPin(): UseMutationResult<KeywordPinView, Error, UpdateKeywordPinVariables> {
	const userSession = useUserSession();
	const queryClient = useQueryClient();

	return useMutation<KeywordPinView, Error, UpdateKeywordPinVariables>({
		mutationFn: async ({ id, row }) => {
			const result = await userSession.webServiceHelper.callWebServiceAsync<KeywordPinView>(
				ImpersonationBroker.composeApiUrl({ urlPath: `user/coffee/customizations/${KEYWORD_PINS_TYPE}/${id}` }),
				'PUT',
				row
			);
			if (!result.success) {
				throw asApiError(result);
			}
			return result.value;
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: queryKeys.focusedView.keywordPins() });
		},
		onError: () => {
			toast.error('Failed to save keyword pin');
		},
	});
}
